module.exports = __webpack_public_path__ + "img/CompScope_BASE.acab3197.png";